<div class="options-container" *ngIf="options">

  <mat-radio-group cdkDropList *ngIf="!multiple"
                   class="options"
                   [cdkDropListDisabled]="readonly"
                   (cdkDropListDropped)="onOptionDrop($event)">
    <div cdkDrag *ngFor="let option of options"
         class="option"
         [cdkDragData]="option">
      <div class="button-drag" cdkDragHandle *ngIf="!readonly"
           matTooltip="Переместить ответ">
        <mat-icon>unfold_more</mat-icon>
      </div>
      <mat-radio-button class="button"
                        [value]="option.id.toString()"
                        [checked]="option.isCorrect"
                        [disabled]="readonly || testType === 'POLL'"
                        (change)="onOptionRadioChange(option, $event)"></mat-radio-button>
      <app-answer-option-edit-form class="text"
                                   [readonly]="readonly"
                                   [testId]="testId"
                                   [questionId]="questionId"
                                   [option]="option"
                                   [allOptions]="options"
                                   (update)="onOptionUpdate($event)"
                                   (delete)="onOptionDelete(option)"></app-answer-option-edit-form>
    </div>
  </mat-radio-group>

  <section cdkDropList *ngIf="multiple"
           class="options"
           [cdkDropListDisabled]="readonly"
           (cdkDropListDropped)="onOptionDrop($event)">
    <div cdkDrag *ngFor="let option of options"
         class="option"
         [cdkDragData]="option">
      <div class="button-drag" cdkDragHandle *ngIf="!readonly"
           matTooltip="Переместить ответ">
        <mat-icon>unfold_more</mat-icon>
      </div>
      <mat-checkbox class="button"
                    [value]="option.id.toString()"
                    [checked]="option.isCorrect"
                    [disabled]="readonly || testType === 'POLL'"
                    (change)="onOptionCheckChange(option, $event)"></mat-checkbox>
      <app-answer-option-edit-form class="text checkbox"
                                   [readonly]="readonly"
                                   [testId]="testId"
                                   [questionId]="questionId"
                                   [option]="option"
                                   [allOptions]="options"
                                   (update)="onOptionUpdate($event)"
                                   (delete)="onOptionDelete(option)"></app-answer-option-edit-form>
    </div>
  </section>

</div>

<app-answer-option-create-form *ngIf="!readonly"
                               [testId]="testId"
                               [questionId]="questionId"
                               [options]="options"
                               (create)="onOptionCreate($event)"></app-answer-option-create-form>
